// extracted by mini-css-extract-plugin
export default {"header":"CustomShapes_header__9oJVY","description":"CustomShapes_description__rQzRM","list":"CustomShapes_list__Z68Uv"};